// ! FIX ME: Refactor this
import {
  JsonApiQueryParameters,
  formatQueryForJsonApi,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from 'evolve-ui';

export type ILocation = {
  id: string;
  name: string;
};

// Define a service using a base URL and expected endpoints
export const locationsApi = createApi({
  reducerPath: 'locations',
  baseQuery: fetchBaseQuery({
    // ! FIX ME: Change this
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/addresses`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Locations'],
  endpoints: (builder) => ({
    getLocations: builder.query<
      { values: ILocation[] },
      JsonApiQueryParameters
    >({
      providesTags: ['Locations'],
      query: (params) => formatQueryForJsonApi(params, 'locations'),
      transformResponse: transformResponseFromJsonApi<ILocation>,
    }),
  }),
});

export const { useGetLocationsQuery } = locationsApi;
